import { FormControlLabel, Switch, SxProps, Theme, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface OwnershipSwitchProps {
  isBannerOwned: boolean
  onChange: (ownership: 'banner' | 'merchant') => void
  sx?: SxProps<Theme>
}

const OwnershipSwitch = ({ isBannerOwned, onChange, sx }: OwnershipSwitchProps) => {
  const { t } = useTranslation()
  return (
    <FormControlLabel
      labelPlacement="top"
      label={
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center', minWidth: 56 }}>
          {isBannerOwned ? t('banner.ownership.banner') : t('banner.ownership.merchant')}
        </Typography>
      }
      control={
        <Switch
          checked={!isBannerOwned}
          size="small"
          onChange={(e) => onChange(e.target.checked ? 'merchant' : 'banner')}
        />
      }
      sx={{ m: 0, ...sx }}
    />
  )
}

export default OwnershipSwitch
